var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t(
          "Webheader.connector_list_" + _vm.msgType + "_" + _vm.entitiesType
        ),
        "show-refresh": true,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { refresh: _vm.onRefresh },
    },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              text: _vm.$t("common.bck"),
              icon: "fa-light fa-arrow-left",
              variant: "primary",
            },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { staticClass: "listPage", attrs: { fluid: "" } },
            [
              _c(
                "b-tabs",
                {
                  staticClass: "p-3 w-100",
                  attrs: { "content-class": "mt-3", "nav-class": "d-none" },
                  model: {
                    value: _vm.tabIndex,
                    callback: function ($$v) {
                      _vm.tabIndex = $$v
                    },
                    expression: "tabIndex",
                  },
                },
                [
                  _c(
                    "b-tab",
                    { attrs: { title: "S3" } },
                    [
                      _c(
                        "b-col",
                        { attrs: { md: "12" } },
                        [
                          _vm.activateSpinner
                            ? _c("spinner")
                            : _c(
                                "div",
                                [
                                  _vm.S3ConfigList.length > 0
                                    ? _c("b-table", {
                                        staticClass: "mt-3 table-striped",
                                        attrs: {
                                          hover: "",
                                          responsive: "",
                                          items: _vm.S3ConfigList,
                                          fields: _vm.S3ConfigFields,
                                          selectable: "",
                                          "select-mode": "single",
                                        },
                                        on: {
                                          "row-selected":
                                            _vm.seeS3ConfigDetails,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "cell(Prefix)",
                                              fn: function (data) {
                                                return [
                                                  data.item.Prefix !== ""
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            data.item.Prefix
                                                          )
                                                        ),
                                                      ])
                                                    : data.item
                                                        .PrefixArchiving !== ""
                                                    ? _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            data.item
                                                              .PrefixArchiving
                                                          ) + " "
                                                        ),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(" - "),
                                                      ]),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2455144747
                                        ),
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex justify-content-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "noResult" },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.$t("common.no_result")
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }